








































































import {Component, Ref, Vue} from "vue-property-decorator"
import DatePicker from "@/components/DatePicker.vue"
import ErrorMessage from "@/components/ErrorMessage.vue"
import moment from "moment"
import {vxm} from "@/store"
import {Validation} from "@/lib/Validation"
import {FlushMessageType, Site} from "@/interface"
import API from "@/api"

@Component({components: {DatePicker, ErrorMessage}})
export default class DebugTestPush extends Vue {

  private token: string = ""
  private domain: string = ""
  private title: string = ""
  private body: string = ""
  private url: string = ""
  private image: string = ""

  @Ref() uploadField!: HTMLInputElement

  private load_ogp: boolean = false

  private errors: {
    token?: string[],
    domain?: string[],
    url?: string[],
    title?: string[],
    body?: string[],
    image?: string[],
  } = {}

  get site(): Site | null {
    return vxm.site.sites.find(s => s.id === vxm.app.selected_site_id) || null
  }

  mounted() {
    if (this.site) {
      this.domain = this.site.domain
    }
  }

  async onClickGetOGP() {
    try {
      this.load_ogp = true
      const response = await API.ogp({url: this.url})
      this.title = response.ogTitle || ""
      this.body = response.ogDescription || ""
      this.image = response.ogImage.url || ""

      const site = vxm.site.sites.find(site => site.id === vxm.app.selected_site_id)
      if (site) {
        const title_regexp    = site.title_regexp || null
          , title_replacement = site.title_replacement || ""
          , body_regexp       = site.body_regexp || null
          , body_replacement  = site.body_replacement || ""
        if (title_regexp !== null) {
          this.title = this.title.replace(new RegExp(title_regexp), title_replacement)
        }
        if (body_regexp !== null) {
          this.body = this.body.replace(new RegExp(body_regexp), body_replacement)
        }
      }
    } catch (e) {
      vxm.app.addFlushMessage({
        type   : FlushMessageType.ERROR,
        message: "An error has occurred"
      })
    } finally {
      this.load_ogp = false
    }
  }

  async onPush() {

    this.errors = {}
    if (!this.validate()) return

    try {
      await vxm.notification.debug({
        token : this.token,
        domain: this.domain,
        url   : this.url,
        title : this.title,
        body  : this.body,
        image : this.image
      })
      vxm.app.addFlushMessage({
        type   : FlushMessageType.SUCCESS,
        message: "Push successful"
      })
    } catch (e) {
      vxm.app.addFlushMessage({
        type   : FlushMessageType.ERROR,
        message: "An error has occurred"
      })
      console.error(e)
    }
  }

  validate(): boolean {

    const validation = new Validation({
      token : {required: true},
      domain: {required: true},
      url   : {required: true},
      title : {required: true},
      body  : {required: true}
    })

    const check: boolean = validation.validate({
      token : this.token,
      domain: this.domain,
      url   : this.url,
      title : this.title,
      body  : this.body,
      image : this.image
    })

    if (!check) this.errors = validation.getErrors()

    return check
  }
}
